let isInstrumented = false;

const amznTraceHeader = 'x-amzn-trace-id';
const ddTraceHeader = 'x-datadog-trace-id';
/**
 * This function wraps the fetch function to add the x-amzn-trace-id header when x-datadog-trace-id is present.
 */
export function instrumentFetch() {
  if (!isInstrumented) {
    const original = window.fetch;
    window.fetch = function (...args) {
      try {
        const init = args[1] as RequestInit;

        if (init?.headers instanceof Headers) {
          if (init.headers.has(ddTraceHeader)) {
            const traceId = init.headers.get(ddTraceHeader) as string;
            init.headers.set(amznTraceHeader, generateAwsXrayTrace(traceId));
          }
        } else if (Array.isArray(init?.headers)) {
          const traceId = init.headers.find((header) => header[0] === ddTraceHeader);
          if (traceId) {
            init.headers.push([amznTraceHeader, generateAwsXrayTrace(traceId[1])]);
          }
        } else if (init?.headers && init?.headers[ddTraceHeader]) {
          init.headers[amznTraceHeader] = generateAwsXrayTrace(init.headers[ddTraceHeader]);
        }
      } catch {
      }
      return original.apply(this, args);
    };
    isInstrumented = true;
  }
}

function generateAwsXrayTrace(traceId: string) {
  const ts = Math.floor((new Date()).getTime() / 1000).toString(16);
  return `Root=1-${ts}-${traceId}`;
}
